export default async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('copyToClipboard failed:', err);
    return false;
  }
}
